import {Skeleton} from 'antd';
import {Tooltip} from 'antd/es';
import cn from 'classnames';
import React from 'react';

import {CustomLink, ICustomLinkProps} from 'features/provide-custom-link';

import s from './inner-custom-link.module.less';

interface IInnerCustomLinkProps extends ICustomLinkProps {
    isLoading: boolean;
    loadingError: string | undefined;
    actionCode: string;
}

export const InnerCustomLink = ({
    link,
    externalProperties,
    isLoading,
    loadingError,
    actionCode,
}: IInnerCustomLinkProps) => (
    <div className={cn(s['custom-link-button'])}>
        {(() => {
            if (loadingError) {
                return (
                    <Tooltip
                        className={s['custom-link-button__disabled']}
                        title={`Не удалось получить конфигурацию ссылки. Подробнее об ошибке: ${loadingError}`}
                        placement="bottom"
                    >
                        {externalProperties?.title ?? 'Ссылка'}
                    </Tooltip>
                );
            }

            if (isLoading) {
                return (
                    <Skeleton.Button
                        active
                    />
                );
            }

            return (
                <CustomLink
                    link={link}
                    externalProperties={externalProperties}
                    actionCode={actionCode}
                />
            );
        })()}
    </div>
);
